module.exports = __webpack_public_path__ + "images/bug_orange_size_5_f09c654020b2bc7301e925e4634406d3.png";